import ItodoImage from "../../../elements/itodo-img";
import imageone from "../../../../assets/images/sectionaboutcompany.webp";
function SectionAboutCompany1() {
  return (
    <>
      <div className="section-full  p-t110 p-b80 sx-bg-white sx-about-bx1-outer">
        <div className="container">
          <div className="section-content">
            <div className="sx-about-bx1-content-wrap">
              <div className="row">
                <div
                  className="col-lg-6 col-md-12 wow fadeInDown"
                  data-wow-duration="1000ms"
                >
                  <div className="sx-about-bx1-media">
                    <div className="sx-dot-bx">
                      <ItodoImage src="images/about/dotted-pic.png" alt="" />
                    </div>
                    <div className="sx-ab-img-outer">
                      <div className="sx-ab-img-section-2">
                        <img src={imageone} alt="aboutcompanyimage" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6 col-md-12 wow fadeInDown"
                  data-wow-duration="1000ms"
                >
                  <div className="sx-about-bx1-content">
                    <h2 className="sx-title">
                      Welcome to 45Caliber AI
                    </h2>
                    <p>
                      At 45Caliber, our story began with a vision to transform
                      the very fabric of technology through intelligent software
                      solutions. Founded by a team of passionate tech
                      enthusiasts and seasoned developers, we recognized the
                      potential of artificial intelligence and machine learning
                      to change industries and enhance human capabilities. Over
                      the years, we have evolved from a small startup to a
                      prominent player in the tech industry, constantly adapting
                      to new innovations and expanding our skill set. Today, we
                      have established ourselves as leaders in AI development,
                      machine learning solutions, VR and AR development, and
                      custom software services.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionAboutCompany1;
